import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
import auth from "./user/auth";
import dashboard from "./store_dashboard/dashboard";
import userDashboard from "./user/userDashboard";
import promoCode from "./store_dashboard/promoCode";
import products from "./store_dashboard/products";
import services from "./store_dashboard/services";
import rraEbm from "./store_dashboard/rra_ebm";
import expenses from "./store_dashboard/expenses";
import purchasesSuppliers from "./store_dashboard/purchases_suppliers";
import purchasesOrders from "./store_dashboard/purchases_orders";
import purchasesReceipts from "./store_dashboard/purchases_receipts";
import storeAssets from "./store_dashboard/store_assets";
import jack from "./admin/jack";
import adminSubscriptions from "./admin/subscriptions";
import adminEmailVerification from "./admin/emailVerification";
import adminReleases from "./admin/releases";
import adminDeviceVersions from "./admin/deviceVersions";
import adminGroups from "./admin/groups";
import adminStoreManagement from "./admin/storeManagement";
import groups from "./groups";
import catalogGroups from "./catalogGroups";
import transfers from "./transfers";
import productMappings from "./productMappings";
import fulfillmentTickets from "./fulfillmentTickets";
import inventory from "./inventory";
import catalogProducts from "./products";
import catalogPurchases from "./purchases";

export default createStore({
  modules: {
    auth,
    dashboard,
    userDashboard,
    promoCode,
    products,
    services,
    rraEbm,
    expenses,
    purchasesSuppliers,
    purchasesOrders,
    purchasesReceipts,
    storeAssets,
    jack,
    adminSubscriptions,
    adminEmailVerification,
    adminReleases,
    adminDeviceVersions,
    adminGroups,
    adminStoreManagement,
    groups,
    transfers,
    productMappings,
    fulfillmentTickets,
    inventory,
    catalogProducts,
    catalogPurchases,
    catalogGroups,
  },
  plugins: [createPersistedState()],
});
